import React from "react";

import "./Badge.scss";

const Badge = ({
  className = "",
  textClassName = "",
  text = "",
}) => {
  return (
    <div className={"badge " + className}>
      <p className={textClassName}>{text}</p>
    </div>
  );
};

export default Badge;
